<template>
    <div>
        <span style="font-size: 2rem; font-weight: 500;">{{client_step_data.step_name}}</span>
        <div>
            <div v-if="client_step_data.spreadify_views.length > 0">
                <form-plugin :admin="true" @formDataUpdated="updateFormData" :viewData="client_step_data.spreadify_views[0].form_data" :uid="client_step_data.spreadify_views[0].spreadify_uid"></form-plugin>
            </div>
        </div>
    </div>
</template>

<script>
import { ccbAdminState, ccbAdminMethods } from '@/state/helpers'
export default {
    data:() => ({
        current_form_data: {},
        params:{},
    }),
    computed:{
        ...ccbAdminState,
    },
    methods:{
        ...ccbAdminMethods,
        updateFormData(newData){
            //*event fired from <form-plugin>
            this.current_form_data = newData.data;
        },
        reject(){

        },
    },
    mounted(){
        this.params = {
            step_id: this.client_step_data.id,
            form_data:[],
        }
    },
}
</script>

<style>

</style>